module.exports = __webpack_public_path__ + "static/media/FilmCount.090d93c4.svg";